export default class PublicationManagements {
  constructor(params) {
    this.params = params;
  }

  index() {
    new N2Styles.searchBar({
      safeContainer: ".js-table-search",
      showSelector: ".show-table-search",
      visible: this.params.search,
    });
  }
}
